import React from "react";

import { Button } from "reactstrap";

import NavbarPrimary from "../sections/NavbarPrimary.js";
import Footer from "../sections/Footer.js";
import HeaderAboutUs from "../headers/HeaderAboutUs.js";
import FeatureAboutUs from "../sections/FeatureAboutUs.js";
import AboutUsIntel from "../blogs/AboutUsIntel.js";
import Background from "../sections/Background.js";
import CarouselConstant from "../accordions/CarouselConstant.js";

function AboutUs() {
  React.useEffect(() => {
    document.body.classList.add("index");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    let href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    if (
      window.location.href.lastIndexOf("#") > 0 &&
      document.getElementById(href)
    ) {
      document.getElementById(href).scrollIntoView();
    }
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      <NavbarPrimary />
      <div className="wrapper">
        <Button
          className="btn-icon-only back-to-top text-lowercase text-default show"
          color="info"
          name="button"
          type="button"
          onClick={() => {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
          }}
        >
            &alpha;
        </Button>
        <HeaderAboutUs />
        <FeatureAboutUs />
        <AboutUsIntel />
        <CarouselConstant />
        <Background />
        <Footer />
      </div>
    </>
  );
}

export default AboutUs;
